import 'babel-polyfill';
import copy from 'copy-text-to-clipboard';
import toast from '../toast';

$('.messages-list li').on('click', (e) => {
    copy($(e.target).text());
    toast(window.language.message_is_copied);
});

$('.categories-list ul li').on('click', (e) => {
    const subcategory = $(e.target).attr('data-subcategory');
    $('.categories-list ul li').removeClass('active');
    $('.messages-list').removeClass('active');
    $(`.categories-list li[data-subcategory=${subcategory}]`).addClass('active');
    $(`.messages-list[data-subcategory=${subcategory}]`).addClass('active');
});
